import APP_CONST from '../../constants';
import Integration from './Integration';
import { ROUTER_CONST } from '../../router';

export default {
    name: 'integration',
    url: '/integration?{accountId}{ar}',
    component: Integration,
    layout: APP_CONST.LAYOUT_PARTIAL,
    visibility: ROUTER_CONST.STATE_VISIBILITY_PRIVATE
};
